import { render } from "./AddressCheckNotice.vue?vue&type=template&id=4bee8e90"
import script from "./AddressCheckNotice.vue?vue&type=script&lang=js"
export * from "./AddressCheckNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__